module.exports = __webpack_public_path__ + "img/surveys-icon.cdadd9e6.svg";